module.exports = __webpack_public_path__ + "8caa8d9f189518c08f770392c70a399e.MP3";